import { render, staticRenderFns } from "./CallingModal.vue?vue&type=template&id=2bcaea99&scoped=true&"
import script from "./CallingModal.vue?vue&type=script&lang=js&"
export * from "./CallingModal.vue?vue&type=script&lang=js&"
import style0 from "./CallingModal.vue?vue&type=style&index=0&id=2bcaea99&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcaea99",
  null
  
)

export default component.exports